export default __webpack_public_path__ + "static/SR China - Certificate - ISO 9001-15a50ed895d84f65a8f029079031c7eb.pdf";